<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="ep" id="epi">“Maybe one day you wake up and forget what it was to be human. Maybe that happens, and then it’s okay.”</p>
<p class="epc">Dennis Lehane, <span class="epub-i">Mystic River</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?fa4d039c